import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteClassCoachRole from 'hooks/classCoachRole/useDeleteClassCoachRole';
import notificationHandler from 'utils/notifications';

interface IModalDeleteClassCoachRole {
  opened: boolean;
  handleClose: () => void;
  kiloClassCoachRoleId?: string;
}

const ModalDeleteClassCoachRole = ({
  opened,
  kiloClassCoachRoleId,
  handleClose,
}: IModalDeleteClassCoachRole): JSX.Element => {
  const deleteMutation = useDeleteClassCoachRole();

  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    if (kiloClassCoachRoleId) {
      deleteMutation.mutate(kiloClassCoachRoleId, {
        onSuccess: () => {
          successNotification('Coach role for class delete success', `Role successfully deleted.`);
          handleClose();
        },
        onError: error => {
          errorNotification('Coach role for class delete failed', error.response?.data.message);
        },
      });
    }
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Coach Role For Classes</Title>}
      size='auto'
    >
      <Stack>
        <Text>Are you sure you want to delete this role?</Text>
        <Text color='dimmed'>
          This action cannot be undone. It will delete this coach role for all other coaches.
        </Text>
        <Group position='right'>
          <Button
            onClick={handleDelete}
            color='red'
            loading={deleteMutation.isLoading}
            data-cy='submitDeleteClassCoachRoleButton'
          >
            Submit
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalDeleteClassCoachRole;
